import _ from 'lodash';
import Element from './Element';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import mixin from '../privates/utils/mixin';
import * as members from '../privates/privateMembers';

import menuUtils from '../privates/utils/menuUtils';
import {validate} from '../privates/validations/validation';
import monitoring from '../privates/monitoring';


/*
 * @class MobileMenu
 * @summary Provides all functionality related to MobileMenu
 * @classdesc The `MobileMenu` class provides functionality related to Wix MobileMenu.
 * The component is avaliable only on mobile
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof wix.ui
 * @tagname MobileMenu
 * @viewername wysiwyg.viewer.components.mobile.TinyMenu
 * @definitionId wysiwyg.viewer.components.mobile.TinyMenu
 */
class MobileMenu extends Element {

    /*
     * @member accountNavBar
     * @label property
     * @syntax
     * @summary Gets an object containing function to preform on accountNavBar when its available on mobile menu.
     * @memberof $w.MobileMenu
     * @readonly
     */
    get accountNavBar() {
        const RMI = members._RMI.get(this);
        const contextId = members._contextId.get(this);
        const type = members._type.get(this);
        const compId = members._compId.get(this);
        return new WrappedAccountNavBarOptions(RMI, compId, contextId, type);
    }
}

mixin(MobileMenu.prototype, HiddenCollapsedMixin.prototype);

export default MobileMenu;


class AccountNavBarOptions {
    constructor(RMI, compId, contextId, type) {
        members._RMI.set(this, RMI);
        members._contextId.set(this, contextId);
        members._type.set(this, type);
        members._compId.set(this, compId);
    }

    set menuItems(menuItems) {
        const RMI = members._RMI.get(this);
        const compType = members._type.get(this).compType;
        const compId = members._compId.get(this);
        const compName = RMI.getId(compId);
        if (!validate({
            compType,
            functionName: 'menuItems',
            dataToValidate: {menuItems},
            compName
        })) {
            return this;
        }
        if (_.isNil(menuItems)){
            menuItems = [];
        }
        const validMenuItems = menuUtils.checkUserProfileTinyMenuItemsValidation({
            navItems: menuItems,
            functionName: 'menuItems',
            compName
        });
        const convertedMenuItems = _.map(validMenuItems, (menuItem, menuItemIndex) => {
            return menuUtils.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'menuItems');
        });
        const currentData = RMI.getData(compId);
        const loginSocialBarRef = _.get(currentData, 'loginSocialBarRef');
        const newData = _.assign(loginSocialBarRef, {menuItemsRef: {type: 'CustomMenuDataRef', menuRef: {type: 'CustomMenu', items: convertedMenuItems}}});
        RMI.setData(members._compId.get(this), {loginSocialBarRef: newData});
    }

    get menuItems() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const data = RMI.getData(compId);
        const menuItems = _.get(data, 'loginSocialBarRef.menuItemsRef.menuRef.items');
        return _.map(menuItems, (item) => {
            return menuUtils.convertNavItemToUserFormat(item, ['visibleOnDesktop']);
        });
    }

    set navBarItems(navBarItems) {
        const RMI = members._RMI.get(this);
        const compType = members._type.get(this).compType;
        const compId = members._compId.get(this);
        const compName = RMI.getId(compId);
        if (!validate({
            compType,
            functionName: 'navBarItems',
            dataToValidate: {navBarItems},
            compName
        })) {
            return this;
        }
        if (_.isNil(navBarItems)){
            navBarItems = [];
        }
        const validNavBarItems = menuUtils.checkUserProfileTinyMenuNavBarItemsValidation({
            navItems: navBarItems,
            functionName: 'navBarItems',
            compName
        });
        const convertedNavItems = _.map(validNavBarItems, (navItem, navItemIndex) => {
            return menuUtils.convertMenuItemToModelFormat(RMI, navItem, navItemIndex, 'navBarItems', true);
        });
        const currentData = RMI.getData(compId);
        const loginSocialBarRef = _.get(currentData, 'loginSocialBarRef');
        const newData = _.assign(loginSocialBarRef, {iconItemsRef: {type: 'CustomMenuDataRef', menuRef: {type: 'CustomMenu', items: convertedNavItems}}});
        RMI.setData(members._compId.get(this), {loginSocialBarRef: newData});
    }

    get navBarItems() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const data = RMI.getData(compId);
        const navBarItems = _.get(data, 'loginSocialBarRef.iconItemsRef.menuRef.items');
        return _.map(navBarItems, (item) => {
            return menuUtils.convertNavItemToUserFormat(item, ['visibleOnDesktop']);
        });
    }
}

const WrappedAccountNavBarOptions = monitoring.monitorClass(AccountNavBarOptions, monitoring.getRavenContextForComponent);

mixin(MobileMenu.prototype, HiddenCollapsedMixin.prototype);
